import type { RedoAdminMarketingRpcClient } from "@redotech/admin-sdk/marketing-rpc/client";
import { createAdminMarketingRpcClient } from "@redotech/admin-sdk/marketing-rpc/client";
import { Context, createContext, ReactNode, useMemo } from "react";
import { getTargetAddressSpace } from "./target-address-space";

export const RedoAdminMarketingRpcClientContext: Context<
  RedoAdminMarketingRpcClient | undefined
> = createContext<RedoAdminMarketingRpcClient | undefined>(undefined);
RedoAdminMarketingRpcClientContext.displayName =
  "RedoAdminMarketingRpcClientContext";

export function RedoAdminMarketingRpcClientProvider({
  children,
  baseUrl,
  authToken,
}: {
  children: ReactNode | ReactNode[];
  baseUrl: string;
  authToken?: string;
}) {
  const redoAdminMarketingRpcClient = useMemo(() => {
    if (!authToken) {
      return undefined;
    }
    const targetAddressSpace = getTargetAddressSpace(baseUrl);
    return createAdminMarketingRpcClient({
      baseURL: new URL(
        `${baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl}/admin-marketing-rpc`,
      ),
      headers: { Authorization: `Bearer ${authToken}` },
      ...(targetAddressSpace && { targetAddressSpace }),
    });
  }, [baseUrl, authToken]);
  return (
    <RedoAdminMarketingRpcClientContext.Provider
      value={redoAdminMarketingRpcClient}
    >
      {children}
    </RedoAdminMarketingRpcClientContext.Provider>
  );
}
